import styled from 'vue-styled-components'
const FileWrapper = styled.div`
cursor: pointer;
background-color: var(--light);

border-radius: 2px;
width: 100%;
padding-top: 100%; /* 1:1 Aspect Ratio */
position: relative;
&::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border: 1px solid #DFDFDF;
    top: 0;
    left: 0;
    border-radius: 2px;
}
&.hightlight {
    box-shadow: var(--primary) 0px 0px 7px;
}
&.active::after {
    border: 3px solid var(--primary);
}
.pdf svg{
    color : #E13022 !important;
}
.word svg{
    color : #3BA9FF !important;
}
.powerpoint svg{
    color : #F89605 !important;
}
.excel svg{
    color : #429600 !important;
}
.txt svg{
    color : #373E44 !important;
}
&.select-img {
    background-color: unset;
    padding-top: 90%; /* 1:1 Aspect Ratio */
    &::after { 
        max-height : 220px; 
        height : 220px; 
    }
}
`;
const WrapperIcon = styled.div`
    position:relative;
    z-index :100;
    width : 87.9px;
    min-width : 87.9px;
    max-width : 87.9px;
`;
const IconWrapper = styled.div`
cursor: pointer;
border-radius: 2px;
width: 100%;
padding-top: 100%; /* 1:1 Aspect Ratio */
position: relative;
&::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 2px;
}
&.hightlight {
    box-shadow: var(--primary) 0px 0px 7px;
}
&.active::after {
    border: 3px solid var(--primary);
}
&.select-img {
    background-color: unset;
    padding-top: 90%; /* 1:1 Aspect Ratio */
    &::after { 
        max-height : 220px; 
        height : 220px; 
    }
}
`;
/* .itm-title {
  width: 150px;
} */
const DirectoryItem = styled.div`
cursor: pointer;
padding: 6px 8px;
&.document {
  display: none !important;
}
&.imageNone {
  display: none !important;
}
span {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}
.tool {
    visibility: hidden;
}
&:hover, &.active {
    background: #F4FCFF;
    border-radius: 4px;
}
&:hover {
    .tool {
        visibility: visible;
    }
}
`

const FileThumbnailProps = {
    imgsrc: String
}
// min-height: 125px;
// max-height: 100%;
// max-width: 100%;
const FileThumbnail = styled('div', FileThumbnailProps)`
background-image: url("${({ imgsrc }) => imgsrc}");
background-size: contain;
background-position: center;
background-repeat: no-repeat;
position: absolute;
top: 0;
left: 0;
bottom: 0;
right: 0;
    &.select-img {
        background-color: var(--light);
        max-height : 220px; 
        height : 220px; 
    }
    .icon-name-list {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        svg {
            font-size: 22px;
        }
    }
    .icon-name {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: calc(100% - 32px);
        svg {
            font-size: 48px;
        }
        .name {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            line-height : 1.5;
        }
    }
`
const IconThumbnailProps = {
    imgsrc: String
}
const IconThumbnail = styled('div', IconThumbnailProps)`
background-image: url("${({ imgsrc }) => imgsrc}");
background-size: contain;
background-position: center;
background-repeat: no-repeat;
position: absolute;
top: 0;
left: 0;
bottom: 0;
right: 0;
    &.select-img {
        max-height : 220px; 
        height : 220px; 
    }
`;
const WrapperProps = {
    width: Number
}
const Wrapper = styled('div', WrapperProps)`
    position: relative;
    ${({ width }) => width && `width: ${width}px;`}
    ${({ width }) => width && `max-width: ${width}px;`}
    ${({ width }) => width && `min-width: ${width}px;`}
    min-height: 70vh;
    max-height: 70vh;
    overflow-y: scroll;
    overflow-x: hidden;
    border-right: 1px solid #DFDFDF;
    scrollbar-width: thin;
    scrollbar-color: #aaa #aaa;
    .pageNav {
        .pagination {
            li {
                a,span {
                    font-size: 16px;
                }
            }
            .page-item {
                &.active {
                    .page-link {
                        background-color: var(--primary);
                        border-color: var(--primary);
                    }
                }
            }
        }
    }
    .input-group {
        button {
            &:hover,&:active,&:focus {
                color :#6c757d !important;
                background-color : white !important;
                border-color: #ced4da !important;
                box-shadow : unset !important;
            }
        }
        .search {
            &:focus {
                border-color: #ced4da;
                box-shadow : unset;
            }
        }
    }
    .pageNav {     
        height: 56px;
        position: sticky;
        bottom: -1px;
        background: white;
    }

    .pageNav .pagination {
        height: 24px;
        margin-right: 32px;
        margin-bottom: 0;
    }

    .pageNav .page-item {
        font-size: 12px;
        height: 24px;
    }

    .pageNav .page-link {
        font-size: 12px;
        padding: 1px 6px;
        height: 24px;
    }

    .pageNav .dropdown-select.dropdown .dropdown-toggle.btn {
        padding: 1px 0px 1px 12px;
        height: 24px;
        text-align: left;
    }

    .btn + .btn {
        margin-left: 0px;
    }

    .pageNav .btn {
        font-size: 12px;
    }
`
const ExternalImageWrapper = styled.div`
    background-color: #fff;
    position: sticky;
    bottom: 0;
`

const SelectedFile = styled.div`
    font-size:20px;
    position:absolute;
    top:5px;
    right:5px;
    & > div > div {
        background-color :#ffffff;
        border-radius:50%;
        width:1em;
        height:1em;
        line-height:0;
    }
    svg {
        color:var(--primary)
    }
`;
const SelectedIcon = styled.div`
    font-size:20px;
    position:absolute;
    right:15px;
    z-index:100;
    & > div > div {
        background-color :#ffffff;
        border-radius:50%;
        width:1em;
        height:1em;
        line-height:0;
    }
    svg {
        color:var(--primary)
    }
`;

const ShowImage = styled.div`
    .detail-image {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
        &::-webkit-scrollbar {
            display: none;
        }
    }

`;

const Upload = styled.div`
    z-index : 2;
    position : absolute;
    right: 5px;
    bottom: 5px;
    width: 320px;
    color: white;
    border: 1px solid #dee3e6;
    border-radius: 3px;
    background-color: #373E44;
    .file-uploading { 
        &:hover {
            .check {
                display:none;
            }
            .chevron,.times {
                display:unset !important;
            }
        }
    }
    .lh-1 {
        line-height : 1;
    }
    .upload-header { 
        border-radius: 3px;
        padding: 13px;
        background-color: #373E44;
    }
    .upload-list {
        padding: 13px;
        background-color: #ffffff;
        max-height: 232px;
        overflow-y: scroll;
        overflow-x: hidden;
    }
    .file-uploading {
        align-items : center;
        &:not(:last-child) {
            padding-bottom : 0.5rem;
            margin-bottom : 0.5rem;
            border-bottom: 1px solid #dee3e6;
        }
    }
`;

const FileWrapperList = styled.div`
    .pdf svg{
        color : #E13022;
    }
    .word svg{
        color : #3BA9FF;
    }
    .powerpoint svg{
        color : #F89605;
    }
    .excel svg{
        color : #429600;
    }
    .txt svg{
        color : #373E44;
    }
    .active {
        background-color: #eaf9fb;
    }
    .hightlight {
        border: 1px solid var(--primary) !important;
    }
`;

export {
    ExternalImageWrapper,
    FileWrapperList,
    FileWrapper,
    FileThumbnail,
    Wrapper,
    DirectoryItem,
    SelectedFile,
    ShowImage,
    Upload,
    IconThumbnail,
    IconWrapper,
    SelectedIcon,
    WrapperIcon,
}